import * as React from 'react';
const GlsIcon = props => {
  const fill = props.color ? props.color : '#fff';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="spedizionieri_icon"
      data-name="spedizionieri icon"
      viewBox="0 0 778.69 209.3"
      {...props}
    >
      <defs>
        <style>{`.gls-icon{fill:${fill};fill-rule:evenodd}`}</style>
      </defs>
      <path
        id="path4402"
        d="m617.88 164.83 25.25-129.52h-43.9l-33.48 172.88h80.13l8.23-43.36h-36.22Z"
        className="gls-icon"
      />
      <path
        id="path4404"
        d="M747.4 73.72c8.05 0 15.92 1.28 23.6 3.84l7.68-40.06a280.968 280.968 0 0 0-30.18-2.2c-47.75 0-70.25 28.54-70.25 60.37 0 41.71 42.81 41.16 42.81 59.27 0 8.78-6.59 13.72-19.76 13.72-9.88 0-22.5-2.2-30.18-5.49l-8.23 42.81c11.16 2.38 22.68 3.48 34.03 3.29 42.81 0 72.44-28.54 72.44-63.11 0-40.61-42.81-41.16-42.81-59.27 0-7.68 5.49-12.99 20.85-13.17"
        className="gls-icon"
      />
      <path
        id="path4406"
        d="M531.17 35.49c-65.86 0-108.12 49.39-108.12 109.76 0 37.32 19.76 63.66 70.25 63.66 19.76 0 39.33-3.66 57.63-10.98l15.92-83.42h-43.9l-9.88 51.04c-4.02.91-8.05 1.28-12.07 1.1-21.95 0-29.64-12.07-29.64-28.54 0-29.64 18.11-60.92 55.98-60.92 10.98.37 21.77 2.01 32.38 4.94.91.55 2.2.91 3.29 1.1 3.29 1.65 6.59 2.74 8.78 3.84l9.15-45c-16.1-4.21-32.93-6.4-49.76-6.59"
        className="gls-icon"
      />
      <path
        id="path4408"
        d="m200.05 35.67-11.89 57.44h81.59c-67.69 100.25-201.78 83.24-237.27 41.71C1.93 98.97 28.28 37.87 118.83 0 29.19 27.26-21.12 98.97 8.52 147.26c33.48 54.7 137.93 77.57 230.87 50.86 62.02-21.77 88.54-52.32 98.24-68.78l-15.18 79.39h60.92l33.11-172.88-216.41-.18Z"
        className="gls-icon"
      />
    </svg>
  );
};
export default GlsIcon;
